import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { formateISODateToMoment, formateISODateToStr, getFullName } from "@/utils";
import { formatMoney } from "@/utils/fieldValueConverter";
import { MONTH } from "@/constants/day";
import {
  DEFINITIONS,
  UPLOAD_FIELDS,
  NUMBER_FIELDS,
  DATE_FIELDS,
  MAP_FIELDS,
} from "@/constants/definitions";

const FieldsTable = ({ fields, object, screenshots }) => {
  const styles = StyleSheet.create({
    table: {
      display: "table",
      width: "auto",

      borderWidth: 1,
      borderColor: "#E9E9E9",
      borderStyle: "solid",
      borderRadius: 6,
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "#E9E9E9",
      // minHeight: 22,
    },
    tableRowFirst: {
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
    },
    tableRowLast: {
      borderBottomWidth: 0,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
    },
    tableRowGray: {
      backgroundColor: "#FCFCFC",
    },
    tableCol: {
      width: "50%",
      padding: "5px 10px",
      borderRightWidth: 1,
      borderColor: "#E9E9E9",
      overflow: "hidden",
      // minHeight: 21,
    },
    tableColLast: {
      borderRightWidth: 0,
    },
  });

  const renderFieldValue = (field, value) => {
    switch (true) {
      case field.type === "money": {
        const formattedValue = formatMoney(value);
        return formattedValue ? <Text>{formattedValue}</Text> : null;
      }
      case field.type === "moment":
        return <Text>{formateISODateToMoment(value)}</Text>;
      case field.type === "date":
        return <Text>{formateISODateToStr(value)}</Text>;
      case field.type === "month": {
        const month = MONTH.find((m) => m.value === value);
        return month ? <Text>{month.label}</Text> : <Text>{value}</Text>;
      }
      case MAP_FIELDS.includes(field.type): {
        if (!value) return null;
        const screenshot = screenshots[`${object.uuid}_${field.uuid}`];
        return screenshot ? (
          <Image src={screenshot} style={{ width: "100%" }} />
        ) : null;
      }
      case UPLOAD_FIELDS.includes(field.type):
        return <Text>{value?.original_name}</Text>;
      case DEFINITIONS.includes(field.type): {
        return <Text>{value?.name}</Text>;
      }
      case field.type === "employee": {
        return (
          <Text>
            {getFullName(value?.lastname, value?.firstname, value?.patronymic)}
          </Text>
        );
      }
      case ["text", "mask", ...NUMBER_FIELDS, ...DATE_FIELDS].includes(field.type):
        return <Text>{value}</Text>;
      default:
        return <Text></Text>;
    }
  };

  return (
    <View style={styles.table}>
      {fields.map((field, index) => (
        <View
          key={field.uuid}
          wrap={false}
          style={[
            styles.tableRow,
            index === 0 && styles.tableRowFirst,
            index === fields.length - 1 && styles.tableRowLast,
            index % 2 === 0 && styles.tableRowGray,
          ]}
        >
          <View style={styles.tableCol} wrap={false}>
            <Text>{field.name}</Text>
          </View>
          <View style={[styles.tableCol, styles.tableColLast]} wrap={false}>
            {renderFieldValue(field, object[field.field_name])}
          </View>
        </View>
      ))}
    </View>
  );
};

export default FieldsTable;
